import { trackById } from 'src/app/shared/utils/track-by.util';
import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';
import { ToastService } from 'src/app/services/toast.service';
import { Enum } from 'src/app/models/enum.model';

export interface CreateUserDialogData {
    firstName: string;
    lastName: string;
    createAccount: boolean;
    username: string;
    securityProfileId: number;
    organizationLevelIds: string[];
    roleId: string;
}

@Component({
  standalone: false,
    selector: 'app-create-user-dialog',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: 'createUserDialog.component.html',
})
export class CreateUserDialogComponent implements OnInit, OnDestroy {

    isFormLoading = false;
    isLoading = false;
    securityProfiles: Enum[];
    createAccountInfo = 'If selected, enter user\'s email address as Username.';

    constructor(public dialogRef: MatDialogRef<CreateUserDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CreateUserDialogData,
        private userService: UserService,
        private toastService: ToastService) {
    }

    ngOnInit() {
        this.isFormLoading = true;
        this.securityProfiles = [];
        this.userService.getSecurityProfileLookupList()
            .subscribe(
                result => {
                    this.securityProfiles = result;
                    this.isFormLoading = false;
                },
                error => {
                    this.toastService.showError(error);
                    this.isFormLoading = false;
                }
            );
    }


    ngOnDestroy() {
    }

    public trackById = trackById;

    save() {
        this.isLoading = true;
        this.userService.create(this.data as any)
            .subscribe(
                response => {
                    this.toastService.showSuccess('User created successfully', true);
                    this.isLoading = false;
                    this.dialogRef.close(true);
                },
                error => {
                    this.isLoading = false;
                    this.toastService.showErrors(error, ['FirstName', 'LastName', 'Username', 'SecurityProfileId']);
                }
            );
    }
}
